export default function Skeleton({ className = '', style, variant = 'line', ...props }) {
  const v = String(variant || 'line');
  return <div className={`Skeleton Skeleton--${v} ${className}`.trim()} style={style} {...props} />;
}

